import {createAction, createSlice} from '@reduxjs/toolkit';
import {enqueueSnackbar} from 'notistack';
import {JOBDETAIL_SLICE_NAME} from '@jobseeker/common-core/constants';
import {
  fetchJobDetails,
  followUpJob,
  fetchJobInsights,
  getMagicRank,
} from './thunkServices/jobdetail';
import {JobDetail} from '@jobseeker/common-core/models/job/jobdetail.models';
import {AppState} from '@jobseeker/common-core/types';
import {HYDRATE} from 'next-redux-wrapper';
import {saveJob} from './thunkServices/jobfeed';

const initialState: Partial<JobDetail> = {
  jobDetailInsights: {
    competitionData: {
      '<1 Yr': 5,
      '1-3 Yr': 12,
      '3-5 Yr': 8,
      '5-10 Yr': 18,
      '10-15 Yr': 14,
      '15+ Yr': 1,
    },
    competitionDataRecruiterActions: {
      '<1 Yr': 0,
      '1-3 Yr': 0,
      '3-5 Yr': 0,
      '5-10 Yr': 0,
      '10-15 Yr': 0,
      '15+ Yr': 0,
    },
    appliedData: {
      'Nov 14': 0,
      'Dec 14': 25,
      'Jan 15': 30,
      'Feb 15': 2,
      'Mar 15': 1,
      'Apr 15': 1,
    },
    appliedDataRecruiterActions: {
      'Jun 14': 0,
      'Jul 14': 0,
      'Aug 14': 0,
      'Sep 14': 0,
      'Oct 14': 0,
      'Nov 14': 0,
    },
    viewData: {
      'Nov 14': 0,
      'Dec 14': 238,
      'Jan 15': 285,
      'Feb 15': 19,
      'Mar 15': 9,
      'Apr 15': 9,
    },
    viewDataRecruiterActions: {
      'Jun 14': 0,
      'Jul 14': 0,
      'Aug 14': 0,
      'Sep 14': 0,
      'Oct 14': 0,
      'Nov 14': 0,
    },
    totalApplicantsFromTopBSchool: 19,
    // originallyPosted: null,
    // lastRefreshed: null,
  },
};

const HyDrate = createAction<AppState>(HYDRATE);

const JobDetailSlice = createSlice({
  name: JOBDETAIL_SLICE_NAME,
  initialState,
  reducers: {
    set_initial_state: (state, action) => { 
      return initialState;
    },
    set_jobdetail: (state, action) => {
      return {...state, ...action.payload};
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchJobDetails.fulfilled, (state, action) => {
      if (typeof action.payload === 'object') {
        return {...state, ...action.payload};
      }
    });
    builder.addCase(fetchJobInsights.fulfilled, (state, action) => {
      return {
        ...state,
        jobDetailInsights: action.payload.data,
      };
    });
    builder.addCase(saveJob.fulfilled, (state, action) => {
      // alert(action.payload.message)
      // console.log(action.payload, action, 'jobdetail');
      if (state.id === action.meta?.arg.jobId) {
        // enqueueSnackbar(action.payload.message, {variant: 'success'});
        return {
          ...state,
          saved: action.meta.arg.unsave ? 0 : 1,
        };
      }
    });
    builder.addCase(followUpJob.fulfilled, (state, action) => {
      enqueueSnackbar(action.payload.message, {variant: action.payload.mType});
    });
    builder.addCase(followUpJob.rejected, (state, action) => {
      enqueueSnackbar('Something Went Wrong !', {variant: 'error'});
    });
    builder.addCase(HyDrate, (state, action) => {
      if (!action.payload?.jobDetail) {
        return state;
      }

      return {
        ...state,
        ...action.payload.jobDetail,
      };
    });
    builder.addCase(getMagicRank.fulfilled, (state, action) => {
      return {
        ...state,
        magicRank: action.payload?.magicRank?.rank
          ? `${action.payload?.magicRank?.rank} (${action.payload?.magicRank?.percentile})`
          : action.payload?.error_msg,
      };
    });
    builder.addCase(getMagicRank.rejected, (state, action) => {
      console.error('magicsort: fetching data failed');
    });
  },
});

const reducer = JobDetailSlice.reducer;

export {reducer, initialState};
